const e = (n) => {
  const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(n);
  return r ? {
    r: parseInt(r[1], 16),
    g: parseInt(r[2], 16),
    b: parseInt(r[3], 16)
  } : null;
}, u = (n, r, t) => "#" + (16777216 + (n << 16) + (r << 8) + t).toString(16).slice(1), g = (n, r) => {
  const t = e(n);
  if (!t)
    return n;
  const o = r / 100, s = Math.round(t.r + (255 - t.r) * o), c = Math.round(t.g + (255 - t.g) * o), a = Math.round(t.b + (255 - t.b) * o);
  return u(Math.min(255, s), Math.min(255, c), Math.min(255, a));
}, b = (n, r) => {
  const t = e(n);
  if (!t)
    return n;
  const o = r / 100, s = Math.round(t.r * (1 - o)), c = Math.round(t.g * (1 - o)), a = Math.round(t.b * (1 - o));
  return u(s, c, a);
};
export {
  b as darkenColor,
  e as hexToRgb,
  g as lightenColor,
  u as rgbToHex
};
